import { MenuItem } from '@/common/_types/menuTypes'
import { createSlice } from '@reduxjs/toolkit'

export type MenuState = {
  menus?: MenuItem[]
}

const initialState: MenuState = {
  menus: undefined,
}

export const MenuSlice = createSlice({
  name: 'menu',
  initialState: initialState,
  reducers: {
    setMenus: (state, action) => {
      state.menus = action.payload
    },
  },
})
export const { setMenus } = MenuSlice.actions
